import { Validators } from "@angular/forms"
import { IFormKey } from "src/app/modules/shared/models/forms"
import moment = require("moment")
import { ITableKey } from "src/app/modules/shared/components/basic-table/basic-table.constants"
import { maxAgeValidator } from "src/app/modules/shared/validators/max-document-age.validator"

export const document_change_form_template = {
    tipoDocumento: null,
    numeroDocumento: null,
    dataRilascio: null,
    enteRilascio: { value: null, disabled: true },
    comuneRilascio: null
}

export const document_change_previdence_form_template = {
  effectDate: moment(),
  tipoDocumento: null,
  documentReleaseDate: null,
  documentNumber: null,
  documentReleasePlace: null,
  documentExpirationDate: null,
  enteRilascio: null,
}

export const document_change_previdence_form_validators = {
  effectDate: [Validators.required],
  tipoDocumento: [Validators.required],
  documentReleaseDate: [Validators.required],
  documentNumber: [Validators.required],
  documentReleasePlace: [Validators.required],
  documentExpirationDate: [Validators.required],
  enteRilascio: [Validators.required],
}

export const document_change_form_validators = {
    tipoDocumento: [Validators.required],
    numeroDocumento: [Validators.required],
    dataRilascio: [Validators.required, maxAgeValidator(10)],
    enteRilascio: [Validators.required],
    comuneRilascio: [Validators.required]
}

export const document_change_previdence_form_group_config: IFormKey[] = [
  {
    id: 'previdence-document-type-field',
    label: 'Tipo documento',
    controlName: 'tipoDocumento',
    css: 'col-4',
    type: 'SELECT'
  },
  {
    id: 'previdence-document-number-field',
    label: 'Numero documento',
    controlName: 'documentNumber',
    type: 'INPUT',
    css: 'col-4'
  },
  {
    id: 'previdence-document-release-date',
    controlName: 'documentReleaseDate',
    label: 'Data di rilascio',
    css: 'col-3',
    type: 'DATEPICKER',
  },
  {
    id: 'previdence-document-release-authority-field',
    label: 'Ente di rilascio',
    controlName: 'enteRilascio',
    css: 'col-4',
    type: 'SELECT'
  },
  {
    id: 'previdence-document-release-place-field',
    label: 'Luogo di rilascio',
    controlName: 'documentReleasePlace',
    type: 'INPUT',
    css: 'col-4'
  },
  {
    id: 'previdence-document-expiration-date',
    controlName: 'documentExpirationDate',
    label: 'Data di scadenza',
    css: 'col-3',
    type: 'DATEPICKER',
  },
  {
    id: 'previdence-effect-date',
    controlName: 'effectDate',
    label: 'Data effetto',
    css: 'col-3',
    type: 'DATEPICKER',
    minDate: moment()
  }
]

export const document_change_previdence_table_keys: ITableKey[] = [
  {
    key: 'documentiAnagrafica.descrizioneTipoDocumento',
    label: 'Tipo Documento',
  },
  {
    key: 'documentiAnagrafica.dataRilascio',
    label: 'Data Rilascio',
    pipe: {
      key: 'date',
      value: null
    }
  },
  {
    key: 'documentiAnagrafica.numeroDocumento',
    label: 'Numero Documento'
  },
  {
    key: 'documentiAnagrafica.descrizioneEnteRilascio',
    label: 'Ente Rilascio'
  },
  {
    key: 'documentiAnagrafica.luogoRilascio',
    label: 'Luogo Rilascio'
  },
  {
    key: 'documentiAnagrafica.dataFineValidita',
    label: 'Data Fine Validità',
    pipe: {
      key: 'date',
      value: null
    }
  },
  {
    key: null,
    label: '',
    type: 'ACTION_ICON',
    actionIcon: 'visibility'
  },
];

export const document_change_form_keys: IFormKey[] = [
    {
        id: 'document-type-field',
        label: 'Tipo documento',
        controlName: 'tipoDocumento',
        css: 'col-4',
        type: 'SELECT',
        options: []
    },
    {
        id: 'document-number-field',
        label: 'Numero documento',
        controlName: 'numeroDocumento',
        type: 'INPUT',
        css: 'col-4'
    },
    {
        id: 'document-release-date',
        controlName: 'dataRilascio',
        label: 'Data di rilascio',
        css: 'col-3',
        type: 'DATEPICKER',
        maxDate: moment()
    },
    {
        id: 'document-release-authoruty-field',
        label: 'Ente di rilascio',
        controlName: 'enteRilascio',
        css: 'col-4',
        type: 'SELECT',
        options: []
    },
    {
        id: 'document-release-place-field',
        label: 'Luogo di rilascio',
        controlName: 'comuneRilascio',
        type: 'INPUT',
        css: 'col-4'
    },
]

export interface IDocumentChangeRequest {
    policyNumber: string;
    dateOfIssue: string;
    issuingAuthority: string;
    placeOfIssue: string;
    documentNumber: string;
    documentType: string;
}
